<app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()" />

<app-sidebar></app-sidebar>

<div class="page-wrapper">
  <div class="page-content">
    <div class="container-xxl">
      <router-outlet />
    </div>
    <app-footer />
  </div>
</div>
